import React from "react";
import { Modal } from "react-blueprint-library";
import "../../assets/stylesheets/LogoutWarningModal.scss";
import { isSafari } from "../../common/Functions";

export default function LogoutWarningModal({
  isOpen = false,
  minutesRemaining = 15,
  handleClose = () => {},
}) {
  const getWarningMessage = () => {
    if (minutesRemaining <= 5) {
      return (
        <>
          <h2>Session Expiring Soon!</h2>
          <p className="warning-urgent">
            You will be logged out in <strong>{minutesRemaining} minutes</strong>.
          </p>
          <p>
            Please save your work immediately to avoid losing any unsaved data.
          </p>
        </>
      );
    } else if (minutesRemaining <= 10) {
      return (
        <>
          <h2>Session Expiring Soon</h2>
          <p className="warning-moderate">
            You will be logged out in <strong>{minutesRemaining} minutes</strong>.
          </p>
          <p>
            Please complete your current page and save your information to avoid losing any data.
          </p>
        </>
      );
    } else {
      return (
        <>
          <h2>Session Reminder</h2>
          <p className="warning-notice">
            You will be logged out in <strong>{minutesRemaining} minutes</strong>.
          </p>
          <p>
            Please finish entering your information and save your data before your session expires.
          </p>
        </>
      );
    }
  };

  return (
    <div>
      <div id="logoutWarningModal"></div>
      <Modal
        id="logoutWarningModal"
        show={isOpen}
        className={isSafari() ? "modal-md safari-only-wrapper" : "modal-md"}
        title=""
      >
        <div className="modal-body">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className="modal-header logout-warning-header">
                  <div className="warning-icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="48"
                      height="48"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <circle cx="12" cy="12" r="10"></circle>
                      <line x1="12" y1="8" x2="12" y2="12"></line>
                      <line x1="12" y1="16" x2="12.01" y2="16"></line>
                    </svg>
                  </div>
                  {getWarningMessage()}
                </div>
              </div>
            </div>
          </div>
          <div className="modal-footer">
            <button
              className="btn btn-primary"
              variant="primary"
              onClick={handleClose}
            >
              OK
            </button>
          </div>
        </div>
      </Modal>
    </div>
  );
}
